export { default as CoverImage } from "./CoverImage";



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/CoverImage/index.ts